module.exports = __webpack_public_path__ + "img/customer.bb5326e5.jpg";